import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmEmailRequestsRoute: InvariantJiraRoute = {
	name: 'products-jsm-email-requests',
	path: '/jira/settings/products/jira-service-management-email-requests',
	exact: true,
};
